export const getParentRecordIndex = (
  index: number,
  recordJobId: string,
): string | null => {
  const recordIdMatch = recordJobId?.match(/record-(\d+)$/);

  if (!recordIdMatch || !recordJobId) return null;
  // The engine addresses a record job created FROM another record job by the
  // parent's OWN parent chain extended with the parent's record index. A
  // PLAIN base (single-loop coordinator record-{i}) therefore gets children
  // at parent-record-index-{i}/record-{n}; a PARENTED base (a nested-loop
  // coordinator parent-record-index-{o}/record-{i}) gets them at the
  // compound parent-record-index-{o}-{i}/record-{n} -- hotfix job 78f7e1ef
  // (STR-13906): the update coordinator at parent-record-index-1/record-0
  // wrote its record at parent-record-index-1-0/record-0 (that child's
  // pathParentRecordIndex is "1-0" and its parent.recordJob is the
  // coordinator). An earlier sibling rewrite here matched the engine BEFORE
  // it disambiguated nested paths; against the current engine it resolves
  // children onto the other iterations' coordinators, which carry no record
  // outputs, so every "Record N" rendered empty.
  const parentedMatch = recordJobId.match(
    /^(.*)\/parent-record-index-([\d-]+)\/record-(\d+)$/,
  );
  if (parentedMatch !== null) {
    const [, prefix, parentChain, parentRecordIndex] = parentedMatch;
    return `${prefix}/parent-record-index-${parentChain}-${parentRecordIndex}/record-${index}`;
  }
  return `${recordJobId.replace(/record-\d+$/, "")}parent-record-index-${
    recordIdMatch[1]
  }/record-${index}`;
};

export const getRecordDataId = (
  recordJobId: string,
  recordsCount: number,
): string[] => {
  return new Array(recordsCount)
    .fill(null)
    .map((_, index) => {
      return getParentRecordIndex(index, recordJobId);
    })
    .filter(Boolean) as string[];
};
